/*
* @Author: jack
* @Date:   2020-12-17 16:05:54
* @Last Modified by:   jack
* @Last Modified time: 2020-12-31 21:19:49
*/
import request from '@/utils/request'

export function mapIndex(data) {
  return request({
    url: 'api/travel/map/index',
    method: 'post',
    data
  })
}

export function travelInfo(data) {
  return request({
    url: 'api/travel/get/content',
    method: 'post',
    data
  })
}
export function travelList(data) {
  return request({
    url: 'api/travel/get/list',
    method: 'post',
    data
  })
}
export function travelRegion(data) {
  return request({
    url: 'api/travel/get/region',
    method: 'post',
    data
  })
}
export function articleList(data) {
  return request({
    url: 'api/travel/get/article/list',
    method: 'post',
    data
  })
}
export function articleInfo(data) {
  return request({
    url: 'api/travel/get/article/info',
    method: 'post',
    data
  })
}
export function addPingjia(data) {
  return request({
    url: 'api/travel/content/add/pingjia',
    method: 'post',
    data
  })
}
export function youjizx(data) {
  return request({
    url: 'api/travel/get/cagegory',
    method: 'post',
    data
  })
}
export function youjizxDital(data) {
  return request({
    url: 'api/travel/get/garticle',
    method: 'post',
    data
  })
}
// 图片广场 分类
export function pictureSquare(data) {
  return request({
    url: 'api/travel/ablumphoto_cate',
    method: 'post',
    data
  })
}
//图片广场---列表
export function pictureSquareList(data) {
  return request({
    url: 'api/travel/ablumphoto_list',
    method: 'post',
    data
  })
}
//图片广场---详情
export function pictureSquareDetail(data) {
  return request({
    url: 'api/travel/ablumphoto_detail',
    method: 'post',
    data
  })
}
//影集影展--专辑(相册)
export function pictureAlbum(data) {
  return request({
    url: 'api/travel/ablum_list',
    method: 'post',
    data
  })
}
//影集影展--专辑详情
export function pictureAlbumDetail(data) {
  return request({
    url: 'api/travel/ablum_list_detail',
    method: 'post',
    data
  })
}
//全景VR--云摄影
export function pictureAlbumVR(data) {
  return request({
    url: 'api/travel/vrshootlist',
    method: 'post',
    data
  })
}
//宣传片--短视频
export function videoList(data) {
  return request({
    url: 'api/travel/videolist',
    method: 'post',
    data
  })
}
//宣传片--短时频--视频详情
export function videoListX(data) {
  return request({
    url: 'api/travel/shortvideodetail',
    method: 'post',
    data
  })
}
//宣传片---短视频---播放/点赞
export function dianzan(data) {
  return request({
    url: 'api/travel/videocount',
    method: 'post',
    data
  })
}
//摄影/视频大赛列表
export function competitionList(data) {
  return request({
    url: 'api/travel/shootcompetionlist',
    method: 'post',
    data
  })
}
//摄影大赛--视频大赛---上传图片/视频
export function uploadss(data) {
  return request({
    url: 'api/travel/upload_img',
    method: 'post',
    data
  })
}
//摄影大赛--视频大赛---删除图片/视频
export function del_img(data) {
  return request({
    url: 'api/travel/del_img',
    method: 'post',
    data
  })
}
//大赛详情上部分主题
export function competitionListDetailto(data) {
  return request({
    url: 'api/travel/shootcompetion_detail',
    method: 'post',
    data
  })
}
//大赛详情下半部分列表
export function competitionListDetailfrom(data) {
  return request({
    url: 'api/travel/shootcompetion_delist',
    method: 'post',
    data
  })
}
//短信接口
export function xiaoxi(data) {
  return request({
    url: 'api/travel/send_smscode',
    method: 'post',
    data
  })
}
//参赛接口
export function cansai(data) {
  return request({
    url: 'api/travel/match_shootcompetion',
    method: 'post',
    data
  })
}
//大赛评选结果
export function competitionResults(data) {
  return request({
    url: 'api/travel/getcompetionlist',
    method: 'post',
    data
  })
}
//比赛结果详情
export function competionlist_detail(data) {
  return request({
    url: 'api/travel/getcompetionlist_detail',
    method: 'post',
    data
  })
}
//大赛摄影视频单张--详情
export function shootone_detail(data) {
  return request({
    url: 'api/travel/shootone_detail',
    method: 'post',
    data
  })
}
//游记大赛--详情--下半部分接口
export function themedowntriplist(data) {
  return request({
    url: 'api/travel/themedowntriplist',
    method: 'post',
    data
  })
}
//游记大赛----参赛接口
export function match_themetripcompetion(data) {
  return request({
    url: 'api/travel/match_themetripcompetion',
    method: 'post',
    data
  })
}
//游记大赛详情
export function themetrip_detail(data) {
  return request({
    url: 'api/travel/themetrip_detail',
    method: 'post',
    data
  })
}
//游记播放---点赞接口
export function themetripcount(data) {
  return request({
    url: 'api/travel/themetripcount',
    method: 'post',
    data
  })
}
//游记大赛--编写游记音乐列表
export function thetripaudiolist(data) {
  return request({
    url: 'api/travel/thetripaudiolist',
    method: 'post',
    data
  })
}
//云推介列表
export function cloudpromotion(data) {
  return request({
    url: 'api/travel/cloudpromotion',
    method: 'post',
    data
  })
}
//云推介列
export function cloudpromotiondetail(data) {
  return request({
    url: 'api/travel/cloudpromotiondetail',
    method: 'post',
    data
  })
}
//云推介列
export function selfdrivinglist(data) {
  return request({
    url: 'api/travel/selfdrivinglist',
    method: 'post',
    data
  })
}
//自驾游详情
export function selfdrivingrouteoneday(data) {
  return request({
    url: 'api/travel/selfdrivingrouteoneday',
    method: 'post',
    data
  })
}
//自驾游站点的数据
export function selfdrivingstation(data) {
  return request({
    url: 'api/travel/selfdrivingstation',
    method: 'post',
    data
  })
}
//自驾游站点的数据
export function livebroadcastlist(data) {
  return request({
    url: 'api/travel/livebroadcastlist',
    method: 'post',
    data
  })
}
//直录播的详情
export function livebroadcastde(data) {
  return request({
    url: 'api/travel/livebroadcastde',
    method: 'post',
    data
  })
}
//电子书列表
export function ebooklist(data) {
  return request({
    url: 'api/travel/ebooklist',
    method: 'post',
    data
  })
}
//电子书内容
export function ebook_one_detail(data) {
  return request({
    url: 'api/travel/ebook_one_detail',
    method: 'post',
    data
  })
}
//攻略路书首页
export function cagegory_list(data) {
  return request({
    url: 'api/travel/cagegory_list',
    method: 'post',
    data
  })
}
//直录播的详情
export function liveanchoruser(data) {
  return request({
    url: 'api/travel/liveanchoruser',
    method: 'post',
    data
  })
}
//主播登录之后--接口
export function liveuser_page(data) {
  return request({
    url: 'api/travel/liveuser_page',
    method: 'post',
    data
  })
}
//主播登录之后选择对应市---获得县区
export function liveuser_region(data) {
  return request({
    url: 'api/travel/liveuser_region',
    method: 'post',
    data
  })
}

//直播县区对应的直播列表
export function livecast_list(data) {
  return request({
    url: 'api/travel/livecast_list',
    method: 'post',
    data
  })
}

// 主播需要的token--频道
export function Livehubanchor(data) {
  return request({
    url: 'api/travel/Livehubanchor',
    method: 'post',
    data
  })
}
//主播开始直播
export function Livehubanchorstart(data) {
  return request({
    url: 'api/travel/Livehubanchorstart',
    method: 'post',
    data
  })
}
//结束直播
export function Livehubanchorend(data) {
  return request({
    url: 'api/travel/Livehubanchorend',
    method: 'post',
    data
  })
}
//开始录制
export function startbroadcast(data) {
  return request({
    url: 'api/travel/startbroadcast',
    method: 'post',
    data
  })
}
//结束录制
export function endbroadcast(data) {
  return request({
    url: 'api/travel/endbroadcast',
    method: 'post',
    data
  })
}
//首页菜单功能接口
export function menuname(data) {
  return request({
    url: 'api/travel/menuname',
    method: 'post',
    data
  })
}
//新版节庆列表
export function holidaylist(data) {
  return request({
    url: 'api/travel/holidaylist',
    method: 'post',
    data
  })
}
//新版节庆详情
export function holidaydetail(data) {
  return request({
    url: 'api/travel/holidaydetail',
    method: 'post',
    data
  })
}
//新版节庆资讯详情
export function holidaynews(data) {
  return request({
    url: 'api/travel/holidaynews',
    method: 'post',
    data
  })
}
//新版节庆活动资料
export function holidaymeet(data) {
  return request({
    url: 'api/travel/holidaymeet',
    method: 'post',
    data
  })
}
//新版节庆活动资料详情
export function holidaymeetdetail(data) {
  return request({
    url: 'api/travel/holidaymeetdetail',
    method: 'post',
    data
  })
}
//大赛评委登录接口
export function judgerlogin(data) {
  return request({
    url: 'api/travel/judgerlogin',
    method: 'post',
    data
  })
}
//评审大赛主题图
export function judgercompetionlist(data) {
  return request({
    url: 'api/travel/judgercompetionlist',
    method: 'post',
    data
  })
}
//评审大赛列表
export function judgercompetiondetail(data) {
  return request({
    url: 'api/travel/judgercompetiondetail',
    method: 'post',
    data
  })
}
//评分接口
export function judgerworkgrade(data) {
  return request({
    url: 'api/travel/judgerworkgrade',
    method: 'post',
    data
  })
}
//评选结果
export function judgerresult(data) {
  return request({
    url: 'api/travel/judgerresult',
    method: 'post',
    data
  })
}
//天气预报
export function areaweather(data) {
  return request({
    url: 'api/travel/areaweather',
    method: 'post',
    data
  })
}
//智能客服搜索接口
export function mindlist(data) {
  return request({
    url: 'api/travel/get/mindlist',
    method: 'post',
    data
  })
}
//微信jssdk
export function jsapi_ticket(data) {
  return request({
    url: 'api/travel/jsapi_ticket',
    method: 'post',
    data
  })
}

//地图游览点语音  
export function scenicaudio(data) {
  return request({
    url: 'api/travel/get/scenicaudio',
    method: 'post',
    data
  })
}
//线路导航
export function lineNavigation(data) {
  return request({
    url: 'api/travel/get/lineNavigation',
    method: 'post',
    data
  })
}
//服务设施
export function serviceFacility(data) {
  return request({
    url: 'api/travel/get/serviceFacility',
    method: 'post',
    data
  })
}
//全国地区
export function citys(data) {
  return request({
    url: 'api/travel/cityjson',
    method: 'post',
    data
  })
}

//怀远中学调查问卷
export function surveyquestion(data) {
  return request({
    url: 'api/travel/surveyquestion',
    method: 'post',
    data
  })
}
//景区语音导览接口
export function audiodetail(data) {
  return request({
    url: 'api/travel/get/audiodetail',
    method: 'post',
    data
  })
}
//节庆管理--云摄影
export function vrshootlist(data) {
  return request({
    url: 'api/travel/vrshootlist',
    method: 'post',
    data
  })
}
//节庆管理--云摄影详情
export function holshootsphoto(data) {
  return request({
    url: 'api/travel/holshootsphoto',
    method: 'post',
    data
  })
}
//节庆管理--图片直播
export function holidaybroad(data) {
  return request({
    url: 'api/travel/holidaybroad',
    method: 'post',
    data
  })
}
//节庆录播视频详情
export function holidaybroaddetail(data) {
  return request({
    url: 'api/travel/holidaybroaddetail',
    method: 'post',
    data
  })
}
//景区楼层游览点
export function scenicaudios_floor(data) {
  return request({
    url: 'api/travel/get/scenicaudios_floor',
    method: 'post',
    data
  })
}

//最新改版的首页接口
export function cate_index(data) {
  return request({
    url: 'api/travel/get/cate_index',
    method: 'post',
    data
  })
}